import React, { useState, useEffect, useRef } from 'react';
import Element from './Element';
import ElementList from './ElementList';
import './index.css';
import { deleteLayout, getLayout, saveLayout } from '../hooks/apiHandler';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Add as AddIcon, Edit as EditIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import { useAuth } from '../hooks/useAuth';

const LayoutBuilder = () => {
  const theme = useTheme();
  const { Logout } = useAuth();

  // Detect screen sizes based on MUI breakpoints
  const isMedium = useMediaQuery(theme.breakpoints.up("md")); // 600px - 900px

  // States for managing layouts
  const [layouts, setLayouts] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState(null); // This checks the selected layout

  const handleSaveLayout = () => {
    var allElements = rearrangeIDs(elements);
    console.log('Handle to save this Layout');
    if (selectedLayout) {
      console.log('We need to update main array...');
      console.log(layouts); // This is the main Array..

      const updatedLayouts = layouts.map(layout =>
        layout.planName === selectedLayout.planName ? { ...layout, layoutElement: allElements } : layout
      );

      // console.log(updatedLayouts); // Check updated layouts
      setLayouts(updatedLayouts);

      let dataToserver = updatedLayouts.find(layout => layout.planName === selectedLayout.planName);
      // Uncomment to save the layout to the server
      console.log(dataToserver);
      saveLayout({
        storeID: storeID,
        _id: dataToserver._id,
        planName: dataToserver.planName,
        layout: { canvasHeight: canvas.height, canvasWidth: canvas.width, elements: dataToserver.layoutElement }
      },Logout).then(res => {
        console.log('Layout saved:', res);
      });
    }
  };

  const handleEditLayoutName = (index, newName) => {
    const updatedLayouts = [...layouts];
    updatedLayouts[index].planName = newName;
    setLayouts(updatedLayouts);

    if (selectedLayout) {
      setSelectedLayout(updatedLayouts[index]); // Ensure selected layout is updated
    }
  };

  // Manage elements
  const storeID = JSON.parse(window.localStorage.getItem('ds'));
  const [elements, setElements] = useState([]);
  const [etype, setEType] = useState({ table: 1, counter: 1 });
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState({ height: null, width: null });
  const [tableSize] = useState({ tlength: 70, twidth: 70 });

  const handleAddLayout = () => {
    const newLayoutName = prompt('New name:');
    console.log(newLayoutName);
    if (newLayoutName != null && newLayoutName.trim() !== '') {
      const newLayout = {
        planName: newLayoutName,
        layoutElement: []
      };

      setLayouts([...layouts, newLayout]);
      setSelectedLayout(newLayout); // Select newly created layout
      setElements([]);

    } else {
      console.log('Something is not proper...');
    }
  };
  const handleDeleteLayoutName = (data) => {
    console.log(data);
    deleteLayout({
      storeID: storeID,
      id: data
    }, Logout).then((res) => {
      setLayouts(res.data);
    })
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getLayout({ storeID },Logout);
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
        return null;
      }
    }

    async function fetchDataAndSetState() {
      const savedElements = await fetchData();
      if (await savedElements) {
        if (savedElements.length > 0) {
          console.log(savedElements);
          setLayouts(savedElements);
          setSelectedLayout(savedElements[0]);
          setElements(savedElements[0].layoutElement);
          setCanvas({ height: savedElements[0].canvasHeight, width: savedElements[0].canvasWidth });
          return;
        }
      } 
      console.log('this need to be called if no canvas height and width is found..');
      if (canvasRef.current) {
        const canvasWidth = canvasRef.current.offsetWidth;
        const canvasHeight = canvasRef.current.offsetHeight;
        setCanvas({ height: canvasHeight, width: canvasWidth });
      }
      
    }
    fetchDataAndSetState(); // Make sure this gets called to load data
  }, [storeID, Logout]);

  const handleAddElement = (type) => {
    console.log('Time to check for functional');
    console.log(selectedLayout);
    if (selectedLayout) {
      if (!canvas.height || !canvas.width) {
        console.error('Canvas size not available');
        return;
      }

      let tid = type === 'table' ? etype.table : etype.counter;
      setEType(prevState => ({ ...prevState, [type]: prevState[type] + 1 }));

      const newX = Math.random() * (canvas.width - 100);
      const newY = Math.random() * (canvas.height - 100);

      const newElement = {
        gid: elements.length + 1,
        id: tid,
        type,
        name: type,
        x: newX,
        y: newY,
        width: (type === 'table') ? tableSize.twidth : 150,
        height: tableSize.tlength,
        lbr: false
      };

      const updatedElements = [...elements, newElement];
      setElements(updatedElements);
    } else {
      alert('Create new Layout or Select Layout..');
    }
  };

  const handleElementPositionChange = (gid, newPosition) => {
    setElements(elements.map(element =>
      element.gid === gid ? { ...element, x: (Math.round(newPosition.x / 5) * 5), y: (Math.round(newPosition.y / 5) * 5) } : element
    ));
  };

  const handleDeleteElement = (gid) => {
    const filteredElements = elements.filter(element => element.gid !== gid);
    const updatedElements = rearrangeIDs(filteredElements);
    setElements(updatedElements);

    if (selectedLayout) {
      setSelectedLayout(prevLayout => ({
        ...prevLayout,
        allElements: updatedElements // Update the elements in the selected layout
      }));
    }
  };

  const rearrangeIDs = (data) => {
    let tableCounter = 0;
    let counterCounter = 0;
    let commonGid = 0;

    const updatedData = [];
    data.forEach((item) => {
      if (item.type === 'table') {
        item.id = ++tableCounter;
        item.gid = ++commonGid;
      } else if (item.type === 'counter') {
        item.id = ++counterCounter;
        item.gid = ++commonGid;
      }
      updatedData.push(item);
    });

    return updatedData;
  };
  return (
    <div>
      {isMedium ?
        <div>
          {/* Layout Management */}
          <div className="extra-controls">
            <div className="layouts-tabs">
              <ul>
                {layouts.length > 0 && (
                  layouts.map((layout, index) => (
                    <li key={index} className={selectedLayout === layout ? 'active' : ''} style={{ alignItems: 'center' }}>
                      <span onClick={() => {
                        setSelectedLayout(layout);
                        setElements([]); // Clear the canvas first
                        setTimeout(() => {  // Ensure elements update after clearing
                          setElements([...layout.layoutElement]);
                        }, 0);
                      }} style={{ fontSize: 20 }}>
                        {layout.planName}
                      </span> &nbsp; &nbsp;
                      <button onClick={() => handleEditLayoutName(index, prompt('New name:', layout.name))}>
                        <EditIcon fontSize="small" />
                      </button>
                      &nbsp;
                      <button onClick={() => handleDeleteLayoutName(layout._id)}>
                        <DeleteOutlineIcon fontSize="small" />
                      </button>
                    </li>
                  ))
                )}
                <button onClick={handleAddLayout}> <AddIcon /> </button>
              </ul>
            </div>
          </div>

          {/* Canvas Section */}
          <div className="layout-builder">
            <div className="controls-container">
              <div className="controls">
                <button className="restaurant-table-button" onClick={() => handleAddElement('table')}>
                  Add Table
                </button>
                <button className="restaurant-table-button" style={{ backgroundColor: 'grey', color: 'white' }} onClick={() => handleAddElement('counter')}>
                  Add Counter
                </button>
                <button onClick={handleSaveLayout}>Save Layout</button>
              </div>
            </div>

            <div className="canvas-container">
              <div className="canvas" ref={canvasRef}>
                <div className="horizontal-center-line"></div>
                {elements.map((element) => (
                  <Element
                    key={element.gid}
                    {...element}
                    canvasHeight={canvas.height}
                    canvasWidth={canvas.width}
                    onPositionChange={(newPosition) => handleElementPositionChange(element.gid, newPosition)}
                    onElementChange={(elementDetail) => {
                      setElements((prevElements) =>
                        prevElements.map((el) =>
                          el.gid === element.gid ? { ...el, ...elementDetail } : el
                        )
                      );
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Element List */}
          <ElementList
            elements={elements}
            onDelete={handleDeleteElement}
            cheigth={canvas.height}
            cwidth={canvas.width}
          />
        </div>
        :
        <div>
          <p>This device Screen is not big enough to Set Layout</p>
        </div>
      }
    </div>
  );
};

export default LayoutBuilder;
